import Svg from '@app/components/svg';

const Fragment = () => (
  <>
    <path
      d="M2.41502 12.9268V37.5968C2.41807 45.3932 4.78254 53.0058 9.19699 59.432C13.6114 65.8583 19.8688 70.7967 27.145 73.5968L34.005 76.2568L40.875 73.6168C48.1512 70.8167 54.4086 65.8783 58.8231 59.452C63.2375 53.0258 65.602 45.4132 65.605 37.6168V12.9268V9.80681L62.775 8.51681C53.707 4.55079 43.9019 2.55024 34.005 2.64681C24.1045 2.54609 14.2953 4.5468 5.22502 8.51681L2.39502 9.80681L2.41502 12.9268Z"
      stroke="currentColor"
      strokeWidth="3.4"
      strokeLinecap="square"
    />
    <path
      d="M50.865 36.6668C50.3976 39.8896 49.0143 42.9104 46.8797 45.3698C44.7451 47.8292 41.9491 49.6238 38.8241 50.54C35.6991 51.4563 32.3767 51.4557 29.252 50.5383C26.1273 49.6209 23.3319 47.8253 21.1982 45.3651C19.0646 42.9049 17.6824 39.8837 17.2162 36.6606C16.7499 33.4376 17.2192 30.1485 18.5682 27.1845C19.9173 24.2205 22.0892 21.7064 24.8258 19.9411C27.5624 18.1758 30.7485 17.2337 34.005 17.2268"
      stroke="currentColor"
      strokeWidth="3.4"
      strokeLinecap="square"
    />
    <path
      d="M51.005 21.4768L35.515 36.9868L34.005 38.4868L32.505 36.9868L27.645 32.0968"
      stroke="currentColor"
      strokeWidth="3.4"
      strokeLinecap="square"
    />
  </>
);

export const SuccessShield = Svg(Fragment, {
  viewBox: '0 0 68 79',
  fill: 'none',
});

SuccessShield.displayName = 'SuccessShield';
